import React, { useEffect, useRef, useState } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import ToastService from '../../services/ToastService'
import AuthService from '../../services/AuthService';
import PropertyService from '../../services/PropertyService';

function AddProperty() {
  const { id } = useParams(); 
  const ClientId = AuthService.getLoggedInClientId();

  const [form, setForm] = useState({
    propertyName: "",
    ownerName: "",
    streetAddress: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    price:"",
    size:"",
    description: "",
    propertyType:"",
    yearBuilt:"",
    bedrooms:"",
    bathrooms:"",
    clientId: ClientId
  });

  const [formError, setFormError] = useState({});

  const navigate = useNavigate();
  const toast = useRef(null);
  const toastService = new ToastService(toast);


  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value,  });
  setFormError((prevErrors) => ({ ...prevErrors, [name]: '' })); 
  };

  const onImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const imageData = reader.result.split(',')[1];
        setForm({ ...form, [fieldName]: imageData });
        setFormError((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
      };
    }
  };
  

  async function saveProperty() {
    const errors = {};
    Object.keys(form).forEach(key => {
      if (!form[key].trim()) {
        errors[key] = `Please enter ${key}`;
      }
    });

    setFormError(errors); 
    if (Object.keys(errors).length > 0) {
      console.error('Validation errors:', errors);
      return;
    }

    const requestData = {
      propertyName: form.propertyName,
      ownerName: form.ownerName,
      streetAddress: form.streetAddress,
      city: form.city,
      state: form.state,
      country: form.country,
      postalCode: form.postalCode,
      price: form.price,
      size: form.size,
      description: form.description,
      propertyType:form.propertyType,
      yearBuilt:form.yearBuilt,
      bedrooms:form.bedrooms,
      bathrooms:form.bathrooms,
      createdBy:0,
      modifiedBy:0,
      isActive: true,
      clientId: ClientId
    };

    
    try {
      if (id) {
        await PropertyService.updateProperty(id, requestData);
        toastService.showSuccess("Success", "Property updated successfully");
      } else {
        await PropertyService.createProperty(requestData);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Property added successfully' });
      }
      resetForm();
      navigate(-1);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const validationErrors = error.response.data.errors;
        setFormError(validationErrors);
      } else {
        console.log("Error saving user:", error);
      }
    }
  }

  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 

    Object.keys(form).forEach((key) => {
      if (!form[key]?.trim()) {
        errors[key] = `Please enter ${key}`;
      }
    });
    
    if (form.email && !emailRegex.test(form.email)) {
      errors.email = "Please enter a valid email address";
    }

    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
        saveProperty();
        
    }
  };

  function resetForm() {
    setForm({
        propertyName: "",
        ownerName: "",
        streetAddress: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        price:"",
        size:"",
        description: "",
        propertyType:"",
        yearBuilt:"",
        bedrooms:"",
        bathrooms:"",
        clientId: ""
    });
    setFormError({});
  }

  return (
    <div>
        <Toast ref={toast} />
        <form onSubmit={onSubmit}> 
        <div className="row m-2 p-2">
            <div className="card text-center mx-auto">
                <div className="card-header bg-heading text-white">
                    New Employee
                </div>

                <div className="card-body text-start text-dark">
 
                <div className="form-group row">
          <label className="col-lg-2" htmlFor="propertyName">
            Property Name
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="propertyName"
            id="propertyName"
            className="form-control"
            value={form.propertyName}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.propertyName}</p>
          </div>
          <label  className="col-lg-2" htmlFor="ownerName">Owner Name</label>

          <div className="col-lg-3">
          <input
            type="text"
            name="ownerName"
            id="ownerName"
            className="form-control"
            value={form.ownerName}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.ownerName}</p>
        </div>
       
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="streetAddress">
           Street Address
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="streetAddress"
            id="streetAddress"
            className="form-control"
            value={form.streetAddress}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.streetAddress}</p>
          </div>

          <label  className="col-lg-2" htmlFor="city">City</label>

<div className="col-lg-3">
<input
  type="text"
  name="city"
  id="city"
  className="form-control"
  value={form.city}
  onChange={changeHandler}
/>
<p className="text-danger">{formError.city}</p>
        </div>
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="state">
          State
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="state"
            id="state"
            className="form-control"
            value={form.state}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.state}</p>
          </div>

          <label className="col-lg-2" htmlFor="country">Country</label>
          <div className="col-lg-3">
          <input
            type="text"
            name="country"
            id="country"
            className="form-control"
            value={form.country}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.country}</p>
        </div>
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="postalCode">Postal Code</label>
          <div className="col-lg-4">
          <input
            type="number"
            name="postalCode"
            id="postalCode"
            className="form-control"
            value={form.postalCode}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.postalCode}</p>
        </div>
 
          <label className="col-lg-2" htmlFor="price">Price</label>
          <div className="col-lg-3">
          <input
            type="number"
            name="price"
            id="price"
            className="form-control"
            value={form.price}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.price}</p>
        </div> 
        </div>
        <div className="form-group row">
        <label className="col-lg-2" htmlFor="size">Size</label>
        <div className="col-lg-4">
          <input
            type="number"
            name="size"
            id="size"
            className="form-control"
            value={form.size}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.size}</p>
          </div>
      
          <label className="col-lg-2" htmlFor="description">Description</label>
          <div className="col-lg-3">
          <input
            type="text"
            name="description"
            id="description"
            className="form-control"
            value={form.description}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.description}</p>
        </div> </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="propertyType">Property Type</label>
        <div className="col-lg-4">
          <input
            type="text"
            name="propertyType"
            id="propertyType"
            className="form-control"
            value={form.propertyType}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.propertyType}</p>
          </div>
       
          <label className="col-lg-2" htmlFor="yearBuilt">Year Built</label>
          <div className="col-lg-3">
          <input
            type="number"
            name="yearBuilt"
            id="yearBuilt"
            className="form-control"
            value={form.yearBuilt}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.yearBuilt}</p>
        </div>
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="bedrooms">Bed Rooms</label>
        <div className="col-lg-4">
          <input
            type="number"
            name="bedrooms"
            id="bedrooms"
            className="form-control"
            value={form.bedrooms}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.bedrooms}</p>
          </div>
       
          <label className="col-lg-2" htmlFor="bathrooms">Bath Rooms</label>
          <div className="col-lg-3">
          <input
            type="number"
            name="bathrooms"
            id="bathrooms"
            className="form-control"
            value={form.bathrooms}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.bathrooms}</p>
        </div>
        </div>
                </div>
                
                <div className="card-footer text-muted bg-light">
                   
                  <button type="submit"  className="btn btn-save btn-dark text-white"> <i className="pi pi-plus"></i>Submit</button>
                  
                </div>
            </div>
        </div>

        </form>

    </div>
  );
}

export default AddProperty;
